<template>
    <div class="panel-ring">
        <div class="panel-ring-top">
            <p class="panel-ring-top-title">主设备</p>
        </div>
        <div class="panel-ring-content">
            <key-value-unit title="监测状态" :value="placeholderText(monitorStatusStr)"></key-value-unit>
        </div>
    </div>
</template>

<script>
import KeyValueUnit from "@c/monitor-center/device-detail-panel/key-value-unit.vue";

// 监测状态枚举
const MONITOR_STATUS = {
    0: '未监测',
    1: '监测中'
};

export default {
    components: {
        KeyValueUnit
    },

    props: {
        model: Object
    },

    computed: {
        // 监测状态
        monitorStatusStr() {
            if (this.model.monitorStatus == null) {
                return null;
            }
            return MONITOR_STATUS[this.model.monitorStatus] || '未知状态';
        }
    },

    methods: {
        placeholderText(text, unit) {
            return placeholderText(text, unit);
        }
    }
}
</script>

<style lang="scss" scoped>
.panel-ring {
    margin-top: rem(20);

    &-top {
        display: flex;
        align-items: center;

        &-title {
            font-size: rem(14);
            line-height: rem(20);
        }

        &-sn {
            margin-left: rem(74);
        }
    }

    &-content {
        display: flex;
        flex-wrap: wrap;

        .key-value-unit {
            margin-top: rem(10);
            width: 50%;
        }

        &-in-charge {
            color: #6CC291;
            font-size: rem(12);
            margin-left: rem(10);
        }
    }
}
</style>